import { render, staticRenderFns } from "./AdminSubpoenas.vue?vue&type=template&id=56b04fb6&scoped=true&"
import script from "./AdminSubpoenas.vue?vue&type=script&lang=js&"
export * from "./AdminSubpoenas.vue?vue&type=script&lang=js&"
import style0 from "./AdminSubpoenas.vue?vue&type=style&index=0&id=56b04fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b04fb6",
  null
  
)

export default component.exports